import React from 'react';
import ReactDOM from 'react-dom';

//登录界面
import Login from './component/common/Login';
//pc布局界面
// import Index from './component/common/Index';
//移动端布局界面
// import MobileChart from './component/trade/demo/MobileChart';
//页面路由界面
import MainRoute from './route/MainRoute'


import * as serviceWorker from './serviceWorker';

// 由于 antd 组件的默认文案是英文，所以需要修改为中文
import moment from 'moment';
import 'moment/locale/zh-cn';
import "antd/dist/antd.css";
//import "./index.css";

// import "@babel/polyfill";
import "core-js";
import { checkUnneedLoginPath } from './util/util'

moment.locale('zh-cn');
//1、判断登录状态，如果是已经登录的就不需要再登录了，直接进入主页
//2、如果是无需登录的路径，则也直接进入相应的页面
if (sessionStorage.getItem("loginStatus") === "true" || checkUnneedLoginPath()) {
    // let ua = navigator.userAgent;
    // let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    // 	isIphone =!ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    // 	isAndroid = ua.match(/(Android)\s+([\d.]+)/),
    //     isMobile = isIphone || isAndroid;
    // if(isMobile){
    //     ReactDOM.render(<MobileChart />, document.getElementById('root'));
    // }else{
    //     ReactDOM.render(<MainRoute />, document.getElementById('root'));
    // }
    ReactDOM.render( < MainRoute / > , document.getElementById('root'));
} else {
    ReactDOM.render( < Login / > , document.getElementById('root'));

}

//ReactDOM.render(<App />, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
serviceWorker.register();